import React from 'react';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-cream px-4 py-12 sm:py-16" data-id="element-253" data-mp="321o4o1rphuap">
      <div className="mx-auto max-w-4xl" data-id="element-254" data-mp="2x0qotvu65ccd">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-255" data-mp="2wzp22u3sj1et">
          What’s Inside the Clinical Kit for Obesity Management?
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-ink/70 sm:text-lg" data-id="element-256" data-mp="2o1dd0wikoboh">
          A complete Clinical Pathway designed to support you from the initial assessment through
          long-term follow-up.
        </p>

        <div className="mt-8 space-y-4" data-id="element-257" data-mp="29c7fre3aovj8">
          {volumes.map(volume => <article key={volume.tag} className="overflow-hidden rounded-3xl border border-navy/10 bg-white" data-id="element-258" data-mp="25a41khp8rcu9">
              <div className={`flex items-center gap-2 px-5 py-2.5 ${volume.color}`} data-id="element-259" data-mp="20cbyqsn266ba">
                <span aria-hidden="true" className="text-base leading-none" data-id="element-260" data-mp="334l1v12n7p29">
                  {volume.emoji}
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-261" data-mp="37xnqcuskc8bl">
                  {volume.tag}
                </span>
              </div>
              <div className="p-5" data-id="element-262" data-mp="2y7ckh2pbjp22">
                <h3 className="font-display text-xl font-bold leading-snug text-navy-deep sm:text-2xl" data-id="element-263" data-mp="2y46s9ele8724">
                  {volume.title}
                </h3>
                <p className="mt-2 text-[14px] font-medium leading-relaxed text-ink/70 sm:text-[15px]" data-id="element-264" data-mp="3qtx9vxm8hr2z">
                  {volume.text}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-265" data-mp="3hspd5jzd8yb0">
          <CTAButton label="I want all 6 volumes now" sub="Instant PDF access · Computer, tablet & mobile" data-id="element-266" data-mp="21fr15e2mxpmw" />
        </div>
      </div>
    </section>;
}